import React from "react";
import indiaFlag from "../../../assets/images/flags/india.png";
import ukFlag from "../../../assets/images/flags/uk.png";
import usFlag from "../../../assets/images/flags/usa.png";
import moment from "moment";
import { Link } from "react-router-dom";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import configure from "configure";
export const overDraftBanksColumns = (onEditDraft, confirmDelete) => [
  {
    Header: "ID",
    accessor: "id",
    isShortIcon: true,
    className: "bl_id ",
  },
  {
    Header: "Bank Name",
    accessor: "bank_name",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_bname",
    Cell: (cellProps) => {
      const location = cellProps?.row?.original?.location;
      return (
        <div>
          <img
            src={location == "1" ? indiaFlag : ukFlag}
            value={location}
            className=" me-3 object-fit-cover"
            width={20}
            height={15}
            alt="flag"
          />
          {cellProps?.row?.original?.bank_name}
        </div>
      );
    },
  },
  {
    Header: "Account Number",
    accessor: "account_no",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_accno",
  },
  {
    Header: "Rate (%)",
    accessor: "interest_rate",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_interest",
  },
  {
    Header: "Avl. Limit",
    accessor: "credit_limit",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_interest",
  },
  {
    Header: "Action",
    accessor: "action",
    isInfoIcon: false,
    className: "action-width-shift text-center",
    Cell: (cellProps) => {
      return (
        <div>
          <button
            onClick={() => onEditDraft(cellProps?.row?.original)}
            className="btn action-btn btn-sm me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </button>
          <a
            onClick={() => confirmDelete(cellProps?.row?.original?.id)}
            className="btn btn-sm action-btn btn-danger"
          >
            <i className="fas fa-trash-alt"></i>
          </a>
        </div>
      );
    },
  },
];

export const overDraftOverview = (onViewInterest) => [
  // {
  //     Header: "ID",
  //     accessor: "value",
  //     isShortIcon: true,
  //     className: "bl_id ",
  // },
  {
    Header: "Overdraft",
    accessor: "bank_name",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_bname",
    Cell: (cellProps) => {
      const overdraft = cellProps?.row?.original;
      return (
        <div>
          {overdraft?.label}
          <br />
          <small>
            {" "}
            <i className="bx bx-subdirectory-right fs-6"></i>
            {overdraft?.account_no}
          </small>
        </div>
      );
    },
  },
  {
    Header: "Avl. Limit",
    accessor: "credit_limit",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_accno",
  },
  {
    Header: "Used Amt.",
    accessor: "used_limit",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_interest",
    Cell: (cellProps) => {
      return (
        <div className="">
          {Number(cellProps?.row?.original?.used_limit).toFixed(2)}
        </div>
      );
    },
  },
  {
    Header: "Balance Amt.",
    accessor: "bal_limit",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_interest",
    Cell: (cellProps) => {
      return (
        <div className="">
          {Number(cellProps?.row?.original?.bal_limit).toFixed(2)}
        </div>
      );
    },
  },
  {
    Header: "Interest Amt.",
    accessor: "interest_amount",
    isInfoIcon: true,
    isShortIcon: true,
    className: "bl_interest",
    Cell: (cellProps) => {
      return (
        <div className="text-center">
          {Number(cellProps?.row?.original?.interest_amount).toFixed(2)}
        </div>
      );
    },
  },
  {
    Header: "Action",
    accessor: "action",
    isInfoIcon: true,
    isShortIcon: true,
    className: "",
    Cell: (cellProps) => {
      return (
        <div
          className="d-flex justify-content-center"
          onClick={() => onViewInterest(cellProps?.row?.original)}
        >
          <button className="btn btn-sm me-1 btn-outline-secondary">
            <i className="fas fa-eye"></i>
          </button>
        </div>
      );
    },
  },
];

export const overDraftEntries = (confirmDelete) => [
  {
    Header: "Date",
    accessor: "created_at",
    isInfoIcon: true,
    isShortIcon: true,
    className: "text-center exp-8",
    Cell: (cellProps) => {
      return (
        <div>
          {moment(cellProps.row?.original?.date)?.format("DD-MM-YYYY")}
        </div>
      );
    },
  },
  {
    Header: "Overdraft",
    accessor: "overdraft",
    isInfoIcon: true,
    isShortIcon: true,
    className: "exp-4",
    Cell: (cellProps) => {
      return (
        <span>
          {cellProps.row.original.bank_name} <br />
          <small>
            <i className="bx bx-subdirectory-right fs-6"></i>
            {cellProps.row.original.account_no}
          </small>
        </span>
      );
    },
  },
  {
    Header: "Amount",
    accessor: "amount",
    isInfoIcon: true,
    isShortIcon: true,
    className: "text-center exp-6",
  },
  {
    Header: "Type",
    accessor: "type",
    isInfoIcon: true,
    isShortIcon: true,
    className: "text-center exp-6",
    Cell: (cellProps) => {
      const type = cellProps.row?.original?.type;
      return <div>{type == 0 ? "Withdraw" : "Return"}</div>;
    },
  },
  {
    Header: "Rate(%)",
    accessor: "interest_rate",
    isInfoIcon: true,
    isShortIcon: true,
    className: "text-center exp-8",
  },
  {
    Header: "Action",
    accessor: "action",
    classNames: "text-center",
    Cell: (cellProps) => {
      const data = cellProps?.row?.original;
      const createdAt = new Date(data?.created_at);
      const latestEntry = new Date(
        Math.max(
          ...cellProps?.rows?.map((row) => new Date(row.original.created_at))
        )
      );
      if (createdAt.getTime() === latestEntry.getTime()) {
        return (
          <div className="d-flex justify-content-center">
            <button
              onClick={() => confirmDelete(data?.id)}
              className="btn btn-sm me-1 btn-outline-danger"
            >
              <i className="fas fa-trash-alt text-danger"></i>
            </button>
          </div>
        );
      }
      return <div className="text-center">-</div>;
    },
  },
];

export const performaInvoice = (
  onEditInvoice,
  ondelete,
  isClone,
  onConvertTax
) => [
    {
      Header: "ID",
      accessor: "id",
      isInfoIcon: false,
      className: "text-center id-col",
    },
    {
      Header: "Location",
      accessor: "location",
      isInfoIcon: false,
      className: "text-center date-col",
      Cell: (cellProps) => {
        return (
          <img src={cellProps.row.original.location == 1 ? indiaFlag : usFlag} style={{ height: "20px", width: '30px' }} />
        );
      },
    },
    {
      Header: "Date",
      accessor: "invoice_date",
      isInfoIcon: false,
      className: "text-center date-col",
      Cell: (cellProps) => {
        return (
          <>{moment(cellProps.row.original.invoice_date).format("DD-MM-YYYY")}</>
        );
      },
    },
    {
      Header: () => {
        return <div style={{ textAlign: "center" }}>PRF Invoice</div>;
      },
      accessor: "invoice_number",
      grow: false,
      className: "prf_invoice_box text-center",
      isInfoIcon: true,
    },

    {
      Header: "Customer",
      accessor: "c_company",
      isInfoIcon: true,
      className: "customer-col",
      Cell: (row) => <div>{row.value}</div>,
    },
    {
      Header: "Due Date",
      accessor: "due_date",
      isInfoIcon: false,
      className: "text-center due_date-col",
      Cell: (cellProps) => {
        return (
          <>{moment(cellProps.row.original.due_date).format("DD-MM-YYYY")}</>
        );
      },
    },
    {
      Header: "Amount",
      accessor: "total",
      isInfoIcon: true,
      className: "text-center amount-col",
      Cell: ({ row }) => (
        <div>
          {row?.original?.currency_symbol}{" "}
          {Number(row.original?.total).toFixed(2)}
        </div>
      ),
    },

    {
      Header: () => {
        return <div style={{ textAlign: "center" }}>Action</div>;
      },
      accessor: "action",
      classNames: "text-center action-col",
      Cell: (cellProps) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <Link
                to={`${configure.appUrl}performa-invoice/view/${cellProps?.row?.original?.id}`}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="View Invoice"
              >
                <i className="fas fa-eye"></i>
              </Link>
              <button
                onClick={() => isClone(cellProps?.row?.original?.id)}
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Clone Invoice"
              >
                <i className="fa fa-clone"></i>
              </button>
              <UncontrolledDropdown
                className="dropdown"
                style={{ width: "29px" }}
              >
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <a
                    onClick={() => onEditInvoice(cellProps?.row?.original)}
                    title="Edit Invoice"
                    className="dropdown-item"
                  >
                    <i className="fas fa-pencil-alt pr-10"></i> Edit Invoice
                  </a>
                  {cellProps?.row?.original?.approve == 1 &&
                    cellProps?.row?.original?.tax_inv_no == null ? (
                    <a
                      className="dropdown-item bg-light-success"
                      title="Convert to Tax"
                      onClick={() => onConvertTax(cellProps?.row?.original?.id)}
                    >
                      <i className="fas fa-sync-alt  pr-10 "></i> Convert to Tax
                    </a>
                  ) : null}
                  <a
                    className="dropdown-item"
                    title="Delete Invoice"
                    onClick={() => ondelete(cellProps?.row?.original?.id)}
                  >
                    <i className="fa fa-trash-alt pr-10 me-1 text-danger"></i>
                    Delete Invoice
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </>
        );
      },
    },
  ];

export const ztplTaxInvoice = (
  onPaymentRecord,
  onVoid,
  ondelete,
  onEditInvoice
) => [
    {
      Header: "Sr.No",
      accessor: "id",
      isInfoIcon: false,
      className: "text-center sr-col",
    },
    {
      Header: "Date",
      accessor: "tax_inv_date",
      isInfoIcon: false,
      className: "text-center date-col",
      Cell: (cellProps) => {
        return (
          <div>
            {moment(cellProps?.row?.original?.tax_inv_date).format("DD-MM-YYYY")}
          </div>
        );
      },
    },
    {
      Header: () => {
        return <div style={{ textAlign: "center" }}>Invoice</div>;
      },
      accessor: "tax_inv_no",
      grow: false,
      className: "invoice_box text-center",
      isInfoIcon: true,
    },
    {
      Header: "Customer",
      accessor: "c_company",
      isInfoIcon: true,
      className: "customer-col",
      Cell: (row) => <div>{row.value}</div>,
    },
    {
      Header: "Due Date",
      accessor: "due_date",
      isInfoIcon: false,
      className: "text-center due_date-col",
      Cell: (cellProps) => {
        return (
          <div>
            {moment(cellProps?.row?.original?.due_date).format("DD-MM-YYYY")}
          </div>
        );
      },
    },
    {
      Header: "Amount",
      accessor: "total",
      isInfoIcon: true,
      className: "text-center amount-col",
      Cell: ({ row }) => (
        <div>
          {row.original?.currency_symbol} {Number(row.original?.total).toFixed(2)}
        </div>
      ),
    },
    {
      Header: "Balance Due",
      accessor: "due_amount",
      isInfoIcon: true,
      className: "text-center amount-col",
      Cell: ({ row }) => (
        <div>
          {row?.original?.due_amount <= "0" ? (
            <h4>
              <span className="badge bg-success font-size-12">Fully Paid</span>
            </h4>
          ) : (
            <div>
              {row.original?.currency_symbol}{" "}
              {Number(row.original?.due_amount).toFixed(2)}
            </div>
          )}
        </div>
      ),
    },
    {
      Header: () => {
        return <div style={{ textAlign: "center" }}>Action</div>;
      },
      accessor: "action",
      classNames: "text-center action-col",
      // Cell: (cellProps) => {
      //   const index = cellProps.row.index;
      //   return (
      //     <>
      //       <div className="d-flex justify-content-center">
      //         <Link
      //           to={`${configure.appUrl}finance/view-ztpl/${cellProps?.row?.original?.id}`}
      //           className="btn btn-sm me-1 btn-outline-secondary"
      //           title="View Invoice"
      //         >
      //           <i className="fas fa-eye"></i>
      //         </Link>
      //         <button
      //           className="btn btn-sm me-1 btn-outline-secondary"
      //           title="Payment History & Record"
      //           onClick={() => onPaymentRecord(cellProps?.row?.original)}
      //         >
      //           <i className="fas fa-credit-card"></i>
      //         </button>

      //         <UncontrolledDropdown
      //           className="dropdown"
      //           style={{ width: "29px" }}
      //         >
      //           <DropdownToggle
      //             className="btn btn-sm btn-outline-secondary w-100"
      //             color="white"
      //           >
      //             <i className="mdi mdi-dots-horizontal"></i>
      //           </DropdownToggle>
      //           <DropdownMenu className="dropdown-menu-end">
      //             {/* <Link
      //                                 title="Send Email"
      //                                 className="dropdown-item"
      //                             >
      //                                 <i className="bi bi-envelope-fill pr-10"></i> Send Email
      //                             </Link> */}
      //             <a
      //               onClick={() => onEditInvoice(cellProps?.row?.original)}
      //               title="Edit Invoice"
      //               className="dropdown-item"
      //             >
      //               <i className="fas fa-pencil-alt pr-10"></i> Edit Invoice
      //             </a>

      //             <Link
      //               onClick={() =>
      //                 onVoid(
      //                   cellProps?.row?.original?.id,
      //                   cellProps?.row?.original?.is_void
      //                 )
      //               }
      //               className="dropdown-item"
      //             >
      //               <i className="bi bi-circle-fill pr-10"></i>{" "}
      //               {cellProps?.row?.original?.is_void == 1
      //                 ? "Unvoid Invoice"
      //                 : "Void Invoice"}
      //             </Link>
      //             {index == 0 ? (
      //               <a
      //                 onClick={() => ondelete(cellProps?.row?.original?.id)}
      //                 title="Delete Invoice"
      //                 className="dropdown-item"
      //               >
      //                 <i className="fas fa-trash text-danger pr-10"></i> Delete
      //                 Invoice
      //               </a>
      //             ) : null}
      //           </DropdownMenu>
      //         </UncontrolledDropdown>
      //       </div>
      //     </>
      //   );
      // },
      Cell: cellProps => {
        const rowData = cellProps.row.original
        const index = cellProps.row.index
        const isVoid = rowData.is_void == 1

        return (
          <div className="d-flex justify-content-center">
            <Link
              to={`${configure.appUrl}finance/view-ztpl/${rowData.id}`}
              className="btn btn-sm me-1 btn-outline-secondary"
              style={isVoid ? { pointerEvents: "none", opacity: 0.5 } : {}}
              title="View Invoice"
            >
              <i className="fas fa-eye"></i>
            </Link>

            <button
              className="btn btn-sm me-1 btn-outline-secondary"
              title="Payment History & Record"
              disabled={isVoid}
              style={isVoid ? { pointerEvents: "none", opacity: 0.5 } : {}}
              onClick={() => !isVoid && onPaymentRecord(rowData)}
            >
              <i className="fas fa-credit-card"></i>
            </button>

            <UncontrolledDropdown className="dropdown" style={{ width: "29px" }}>
              <DropdownToggle
                className="btn btn-sm btn-outline-secondary w-100"
                color="white"
              >
                <i className="mdi mdi-dots-horizontal"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">

                {!isVoid && (
                  <>
                    <a
                      onClick={() => onEditInvoice(rowData)}
                      title="Edit Invoice"
                      className="dropdown-item"
                    >
                      <i className="fas fa-pencil-alt pr-10"></i> Edit Invoice
                    </a>

                    {index == 0 && (
                      <a
                        onClick={() => ondelete(rowData.id)}
                        title="Delete Invoice"
                        className="dropdown-item"
                      >
                        <i className="fas fa-trash text-danger pr-10"></i> Delete Invoice
                      </a>
                    )}
                  </>
                )}

                {/* this stays active ALWAYS */}
                <a
                  onClick={() => onVoid(rowData.id, rowData.is_void)}
                  className="dropdown-item"
                >
                  <i className="bi bi-circle-fill pr-10"></i>{" "}
                  {isVoid ? "Unvoid Invoice" : "Void Invoice"}
                </a>

              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )
      },
    },
  ];

// export const zithasTaxInvoice = (
//   onEditInvoice,
//   isClone,
//   onVoid,
//   ondelete,
//   onPaymentRecord
// ) => [
//   {
//     Header: "Sr.No",
//     accessor: "id",
//     isInfoIcon: false,
//     className: "text-center sr-col",
//   },
//   {
//     Header: "Date",
//     accessor: "invoice_date",
//     isInfoIcon: false,
//     className: "text-center date-col",
//     Cell: (cellProps) => {
//       return (
//         <div>
//           {moment(cellProps?.row?.original?.invoice_date).format("DD-MM-YYYY")}
//         </div>
//       );
//     },
//   },
//   {
//     Header: () => {
//       return <div style={{ textAlign: "center" }}>Invoice</div>;
//     },
//     accessor: "invoice_number",
//     grow: false,
//     className: "text-center inv_no_zi",
//     isInfoIcon: true,
//   },
//   {
//     Header: "Customer",
//     accessor: "c_company",
//     isInfoIcon: true,
//     className: "customer-col",
//     Cell: (row) => <div>{row.value}</div>,
//   },
//   {
//     Header: "Due Date",
//     accessor: "due_date",
//     isInfoIcon: false,
//     className: "text-center due_date-col",
//     Cell: (cellProps) => {
//       return (
//         <div>
//           {moment(cellProps?.row?.original?.due_date).format("DD-MM-YYYY")}
//         </div>
//       );
//     },
//   },
//   {
//     Header: "Amount",
//     accessor: "total",
//     isInfoIcon: true,
//     className: "text-center amount-col",
//     Cell: ({ row }) => (
//       <div>
//         {row.original?.currency_symbol} {Number(row.original?.total).toFixed(2)}
//       </div>
//     ),
//   },
//   {
//     Header: "Balance Due",
//     accessor: "balance_due",
//     isInfoIcon: true,
//     className: "text-center amount-col",
//     Cell: ({ row }) => (
//       <div>
//         {row?.original?.balance_due <= "0" ? (
//           <h4>
//             <span className="badge bg-success font-size-12">Fully Paid</span>
//           </h4>
//         ) : (
//           <div>
//             {row.original?.currency_symbol}{" "}
//             {Number(row.original?.balance_due).toFixed(2)}
//           </div>
//         )}
//       </div>
//     ),
//   },

//   {
//     Header: () => {
//       return <div style={{ textAlign: "center" }}>Action</div>;
//     },
//     accessor: "action",
//     classNames: "text-center action-col tab-9",
//     // Cell: cellProps => {
//     //     const index = cellProps.row.index;
//     //     return (
//     //         <>
//     //             <div className="d-flex justify-content-center">
//     //                 <Link to={`${configure.appUrl}finance/view-zithas/${cellProps?.row?.original?.id}`}
//     //                     className="btn btn-sm me-1 btn-outline-secondary"
//     //                     title="View Invoice"
//     //                 >
//     //                     <i className="fas fa-eye"></i>
//     //                 </Link>
//     //                 <button
//     //                     className="btn btn-sm me-1 btn-outline-secondary"
//     //                     title="Payment History & Record"
//     //                     onClick={() => onPaymentRecord(cellProps?.row?.original)}
//     //                 >
//     //                     <i className="fas fa-credit-card"></i>
//     //                 </button>
//     //                 <UncontrolledDropdown
//     //                     className="dropdown"
//     //                     style={{ width: "29px" }}
//     //                 >
//     //                     <DropdownToggle
//     //                         className="btn btn-sm btn-outline-secondary w-100"
//     //                         color="white"
//     //                     >
//     //                         <i className="mdi mdi-dots-horizontal"></i>
//     //                     </DropdownToggle>
//     //                     <DropdownMenu className="dropdown-menu-end">

//     //                         <a
//     //                             title="Clone Invoice"
//     //                             className="dropdown-item"
//     //                             onClick={() => isClone(cellProps?.row?.original?.id)}
//     //                         >
//     //                             <i className="fa fa-clone  pr-10"></i> Clone Invoice
//     //                         </a>
//     //                         <a
//     //                             onClick={() => onEditInvoice(cellProps?.row?.original)}
//     //                             title="Edit Invoice"
//     //                             className="dropdown-item"
//     //                         >
//     //                             <i className="fas fa-pen  pr-10"></i> Edit Invoice
//     //                         </a>

//     //                         <a
//     //                             onClick={() => onVoid(cellProps?.row?.original?.id, cellProps?.row?.original?.is_void)}
//     //                             className="dropdown-item"
//     //                         >
//     //                             <i className="bi bi-circle-fill pr-10"></i> {cellProps?.row?.original?.is_void == 1 ? 'Unvoid Invoice' : 'Void Invoice'}
//     //                         </a>
//     //                         {index == 0 ? (
//     //                             <a
//     //                                 title="Delete Invoice"
//     //                                 className="dropdown-item"
//     //                                 onClick={() => ondelete(cellProps?.row?.original?.id)}
//     //                             >
//     //                                 <i className="fas fa-trash text-danger pr-10"></i> Delete Invoice
//     //                             </a>
//     //                         ) : null}
//     //                     </DropdownMenu>
//     //                 </UncontrolledDropdown>
//     //             </div>
//     //         </>
//     //     )
//     // },
//     Cell: (cellProps) => {
//       const rowData = cellProps.row.original;
//       const isVoid = rowData.is_void == 1;

//       return (
//         <div className="d-flex justify-content-center">
//           <Link
//             to={`${configure.appUrl}finance/view-zithas/${rowData.id}`}
//             className="btn btn-sm me-1 btn-outline-secondary"
//             title="View Invoice"
//             disabled={isVoid}
//             style={isVoid ? { pointerEvents: "none", opacity: 0.5 } : {}}
//           >
//             <i className="fas fa-eye"></i>
//           </Link>

//           <button
//             className="btn btn-sm me-1 btn-outline-secondary"
//             title="Payment History & Record"
//             disabled={isVoid}
//             style={isVoid ? { pointerEvents: "none", opacity: 0.5 } : {}}
//             onClick={() => !isVoid && onPaymentRecord(rowData)}
//           >
//             <i className="fas fa-credit-card"></i>
//           </button>

//           <UncontrolledDropdown className="dropdown" style={{ width: "29px" }}>
//             <DropdownToggle
//               className="btn btn-sm btn-outline-secondary w-100"
//               color="white"
//               //   style={isVoid ? { opacity: 0.5 } : {}}
//             >
//               <i className="mdi mdi-dots-horizontal"></i>
//             </DropdownToggle>

//             <DropdownMenu className="dropdown-menu-end">
//               {/* visible only when NOT void */}
//               {!isVoid && (
//                 <>
//                   <a
//                     className="dropdown-item"
//                     title="Clone Invoice"
//                     onClick={() => isClone(rowData.id)}
//                   >
//                     <i className="fa fa-clone pr-10"></i> Clone Invoice
//                   </a>

//                   <a
//                     className="dropdown-item"
//                     title="Edit Invoice"
//                     onClick={() => onEditInvoice(rowData)}
//                   >
//                     <i className="fas fa-pen pr-10"></i> Edit Invoice
//                   </a>

//                   {cellProps.row.index == 0 && (
//                     <a
//                       className="dropdown-item"
//                       title="Delete Invoice"
//                       onClick={() => ondelete(rowData.id)}
//                     >
//                       <i className="fas fa-trash text-danger pr-10"></i> Delete
//                       Invoice
//                     </a>
//                   )}
//                 </>
//               )}

//               {/* This should always be active – unvoid or void */}
//               <a
//                 className="dropdown-item"
//                 onClick={() => onVoid(rowData.id, rowData.is_void)}
//               >
//                 <i className="bi bi-circle-fill pr-10"></i>{" "}
//                 {isVoid ? "Unvoid Invoice" : "Void Invoice"}
//               </a>
//             </DropdownMenu>
//           </UncontrolledDropdown>
//         </div>
//       );
//     },
//   },
// ];


export const zithasTaxInvoice = (
  onEditInvoice,
  isClone,
  onVoid,
  ondelete,
  onPaymentRecord
) => [
    {
      Header: "Sr.No",
      accessor: "id",
      isInfoIcon: false,
      className: "text-center sr-col",

      Cell: ({ row }) => (
        <>
          {row.original.id}
          {row.original.approve === 0 && "*"}
        </>
      ),
    },
    {
      Header: "Date",
      accessor: "invoice_date",
      isInfoIcon: false,
      className: "text-center date-col",
      Cell: cellProps => {
        return (
          <div>
            {moment(cellProps?.row?.original?.invoice_date).format("DD-MM-YYYY")}
          </div>
        )
      },
    },
    {
      Header: () => {
        return <div style={{ textAlign: "center" }}>Invoice</div>
      },
      accessor: "invoice_number",
      grow: false,
      className: "text-center inv_no_zi",
      isInfoIcon: true,
    },
    {
      Header: "Customer",
      accessor: "c_company",
      isInfoIcon: true,
      className: "customer-col",
      Cell: row => <div>{row.value}</div>,
    },
    {
      Header: "Due Date",
      accessor: "due_date",
      isInfoIcon: false,
      className: "text-center due_date-col",
      Cell: cellProps => {
        return (
          <div>
            {moment(cellProps?.row?.original?.due_date).format("DD-MM-YYYY")}
          </div>
        )
      },
    },
    {
      Header: "Amount",
      accessor: "total",
      isInfoIcon: true,
      className: "text-center amount-col",
      Cell: ({ row }) => (
        <div>
          {row.original?.currency_symbol} {Number(row.original?.total).toFixed(2)}
        </div>
      ),
    },
    {
      Header: "Balance Due",
      accessor: "balance_due",
      isInfoIcon: true,
      className: "text-center amount-col",
      Cell: ({ row }) => (
        <div>
          {row?.original?.balance_due <= "0" ? (
            <h4>
              <span className="badge bg-success font-size-12">Fully Paid</span>
            </h4>
          ) : (
            <div>
              {row.original?.currency_symbol}{" "}
              {Number(row.original?.balance_due).toFixed(2)}
            </div>
          )}
        </div>
      ),
    },
    {
      Header: () => {
        return <div style={{ textAlign: "center" }}>Action</div>
      },
      accessor: "action",
      classNames: "text-center action-col tab-9",
      // Cell: cellProps => {
      //     const index = cellProps.row.index;
      //     return (
      //         <>
      //             <div className="d-flex justify-content-center">
      //                 <Link to={`${configure.appUrl}finance/view-zithas/${cellProps?.row?.original?.id}`}
      //                     className="btn btn-sm me-1 btn-outline-secondary"
      //                     title="View Invoice"
      //                 >
      //                     <i className="fas fa-eye"></i>
      //                 </Link>
      //                 <button
      //                     className="btn btn-sm me-1 btn-outline-secondary"
      //                     title="Payment History & Record"
      //                     onClick={() => onPaymentRecord(cellProps?.row?.original)}
      //                 >
      //                     <i className="fas fa-credit-card"></i>
      //                 </button>
      //                 <UncontrolledDropdown
      //                     className="dropdown"
      //                     style={{ width: "29px" }}
      //                 >
      //                     <DropdownToggle
      //                         className="btn btn-sm btn-outline-secondary w-100"
      //                         color="white"
      //                     >
      //                         <i className="mdi mdi-dots-horizontal"></i>
      //                     </DropdownToggle>
      //                     <DropdownMenu className="dropdown-menu-end">

      //                         <a
      //                             title="Clone Invoice"
      //                             className="dropdown-item"
      //                             onClick={() => isClone(cellProps?.row?.original?.id)}
      //                         >
      //                             <i className="fa fa-clone  pr-10"></i> Clone Invoice
      //                         </a>
      //                         <a
      //                             onClick={() => onEditInvoice(cellProps?.row?.original)}
      //                             title="Edit Invoice"
      //                             className="dropdown-item"
      //                         >
      //                             <i className="fas fa-pen  pr-10"></i> Edit Invoice
      //                         </a>

      //                         <a
      //                             onClick={() => onVoid(cellProps?.row?.original?.id, cellProps?.row?.original?.is_void)}
      //                             className="dropdown-item"
      //                         >
      //                             <i className="bi bi-circle-fill pr-10"></i> {cellProps?.row?.original?.is_void == 1 ? 'Unvoid Invoice' : 'Void Invoice'}
      //                         </a>
      //                         {index == 0 ? (
      //                             <a
      //                                 title="Delete Invoice"
      //                                 className="dropdown-item"
      //                                 onClick={() => ondelete(cellProps?.row?.original?.id)}
      //                             >
      //                                 <i className="fas fa-trash text-danger pr-10"></i> Delete Invoice
      //                             </a>
      //                         ) : null}
      //                     </DropdownMenu>
      //                 </UncontrolledDropdown>
      //             </div>
      //         </>
      //     )
      // },
      Cell: cellProps => {
        const rowData = cellProps.row.original
        const isVoid = rowData.is_void == 1

        return (
          <div className="d-flex justify-content-center">
            <Link
              to={`${configure.appUrl}finance/view-zithas/${rowData.id}`}
              className="btn btn-sm me-1 btn-outline-secondary"
              title="View Invoice"
              disabled={isVoid}
              style={isVoid ? { pointerEvents: "none", opacity: 0.5 } : {}}
            >
              <i className="fas fa-eye"></i>
            </Link>

            {/* <button
            className="btn btn-sm me-1 btn-outline-secondary"
            title="Payment History & Record"
            disabled={isVoid}
            style={isVoid ? { pointerEvents: "none", opacity: 0.5 } : {}}
            onClick={() => !isVoid && onPaymentRecord(rowData)}
          >
            <i className="fas fa-credit-card"></i>
          </button> */}
            <button
              className="btn btn-sm me-1 btn-outline-secondary"
              title="Payment History & Record"
              disabled={isVoid || rowData?.approve == 0}
              style={
                isVoid || rowData?.approve == 0
                  ? { pointerEvents: "none", opacity: 0.5 }
                  : {}
              }
              onClick={() => {
                if (!isVoid && rowData?.approve == 1) {
                  onPaymentRecord(rowData)
                }
              }}
            >
              <i className="fas fa-credit-card"></i>
            </button>

            <UncontrolledDropdown className="dropdown" style={{ width: "29px" }}>
              <DropdownToggle
                className="btn btn-sm btn-outline-secondary w-100"
                color="white"
              //   style={isVoid ? { opacity: 0.5 } : {}}
              >
                <i className="mdi mdi-dots-horizontal"></i>
              </DropdownToggle>

              {/* <DropdownMenu className="dropdown-menu-end">
              
              {!isVoid && (
                <>
                  <a
                    className="dropdown-item"
                    title="Clone Invoice"
                    onClick={() => isClone(rowData.id)}
                  >
                    <i className="fa fa-clone pr-10"></i> Clone Invoice
                  </a>

                  <a
                    className="dropdown-item"
                    title="Edit Invoice"
                    onClick={() => onEditInvoice(rowData)}
                  >
                    <i className="fas fa-pen pr-10"></i> Edit Invoice
                  </a>

                  {cellProps.row.index == 0 && (
                    <a
                      className="dropdown-item"
                      title="Delete Invoice"
                      onClick={() => ondelete(rowData.id)}
                    >
                      <i className="fas fa-trash text-danger pr-10"></i> Delete
                      Invoice
                    </a>
                  )}
                </>
              )}
              <a
                className="dropdown-item"
                onClick={() => onVoid(rowData.id, rowData.is_void)}
              >
                <i className="bi bi-circle-fill pr-10"></i>{" "}
                {isVoid ? "Unvoid Invoice" : "Void Invoice"}
              </a>
            </DropdownMenu> */}

              <DropdownMenu className="dropdown-menu-end">
                {/* Clone Invoice – hide if isVoid OR approval = 0 */}
                {!isVoid && rowData?.approve === 1 && (
                  <a
                    className="dropdown-item"
                    title="Clone Invoice"
                    onClick={() => isClone(rowData.id)}
                  >
                    <i className="fa fa-clone pr-10"></i> Clone Invoice
                  </a>
                )}

                {/* Edit Invoice – show always when NOT void */}
                {!isVoid ? (
                  <a
                    className="dropdown-item"
                    title="Edit Invoice"
                    onClick={() => onEditInvoice(rowData)}
                  >
                    <i className="fas fa-pen pr-10"></i> Edit Invoice
                  </a>
                ) : null}

                {/* Delete Invoice – show only for first row and NOT void */}
                {!isVoid && (
                  <a
                    className="dropdown-item"
                    title="Delete Invoice"
                    onClick={() => ondelete(rowData.id)}
                  >
                    <i className="fas fa-trash text-danger pr-10"></i> Delete
                    Invoice
                  </a>
                )}

                {/* Void / Unvoid Invoice – hide if approval = 0 */}
                {rowData?.approve === 1 && (
                  <a
                    className="dropdown-item"
                    onClick={() => onVoid(rowData.id, rowData.is_void)}
                  >
                    <i className="bi bi-circle-fill pr-10"></i>{" "}
                    {isVoid ? "Unvoid Invoice" : "Void Invoice"}
                  </a>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )
      },
    },
  ]